export const Permissions = {
  DashboardView: 'dashboard.view',
  AdsView: 'ads.view',
  AdsCreate: 'ads.create',
  AdsEdit: 'ads.edit',
  AdsDelete: 'ads.delete',
  ProvidersView: 'providers.view',
  ProvidersEdit: 'providers.edit',
  ProvidersDeactivate: 'providers.deactivate',
  CandidatesView: 'candidates.view',
  CandidatesEdit: 'candidates.edit',
  CandidatesDeactivate: 'candidates.deactivate',
  CvsView: 'cvs.view',
  CvsDownload: 'cvs.download',
  InterviewsView: 'interviews.view',
  InterviewsManage: 'interviews.manage',
  WorkshopsView: 'workshops.view',
  WorkshopsManage: 'workshops.manage',
  PackagesProcessView: 'packages.process.view',
  PackagesProcessManage: 'packages.process.manage',
  OpportunitiesView: 'opportunities.view',
  OpportunitiesCreate: 'opportunities.create',
  OpportunitiesEdit: 'opportunities.edit',
  OpportunitiesDelete: 'opportunities.delete',
  CollectionSourcesManage: 'collection.sources.manage',
  CollectionDraftsReview: 'collection.drafts.review',
  ModeratorsView: 'moderators.view',
  ModeratorsCreate: 'moderators.create',
  ModeratorsEdit: 'moderators.edit',
  ModeratorsAssignRole: 'moderators.assign-role',
  ModeratorsDelete: 'moderators.delete',
  RequestsView: 'requests.view',
  RequestsRespond: 'requests.respond',
  PaymentsView: 'payments.view',
  PaymentsRefund: 'payments.refund',
  PaymentsExport: 'payments.export',
  SystemConfigView: 'system.config.view',
  SystemConfigEdit: 'system.config.edit',
  SystemCouponsView: 'system.coupons.view',
  SystemCouponsEdit: 'system.coupons.edit',
  SystemPackagesView: 'system.packages.view',
  SystemPackagesEdit: 'system.packages.edit',
  SystemPlansView: 'system.plans.view',
  SystemPlansEdit: 'system.plans.edit',
  SystemNotificationsView: 'system.notifications.view',
  SystemNotificationsEdit: 'system.notifications.edit',
} as const;

export type PermissionCode = typeof Permissions[keyof typeof Permissions];
